import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const integerationStore = createApi({
    reducerPath: 'integerationStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        office365Integeration: builder.mutation({
            query: (body) => {
                return {
                    url: 'office365integration/getAccessTokenFromCode/',
                    method: "POST",
                    body: { ...body }
                }
            },
        })
    }),
})

export const {
   useOffice365IntegerationMutation
} = integerationStore;